import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  UpdateDispatchSummaryMarketInput,
  UpdateDispatchSummaryMarketBulkResponse,
  MutationUpdateDispatchSummaryMarketBulkArgs,
  UpdateDispatchSummaryMarketValuesInput,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty, queryInput } from '@/utils';
import graphApi from '@/api';
import { UpdateDispatchSummaryMarket } from '@/features/SummaryHistory/api/queries/UpdateDispatchSummaryMarket';

// Service Function Signature
type ServiceMethodPayload = Partial<UpdateDispatchSummaryMarketValuesInput & { id: string }>[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<UpdateDispatchSummaryMarketBulkResponse>;
}

// UpdateDispatchSummaryMarket Service
export const { updateDispatchSummaryMarket, useUpdateDispatchSummaryMarket } = ((): {
  updateDispatchSummaryMarket: ServiceMethod;
  useUpdateDispatchSummaryMarket: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(UpdateDispatchSummaryMarket).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<UpdateDispatchSummaryMarketBulkResponse> => {
        const updates: UpdateDispatchSummaryMarketInput[] =
          payload
            ?.filter(({ id }) => id)
            ?.map(({ id, ...value }) => ({
              query: [
                {
                  id: queryInput(id),
                },
              ],
              value,
            })) ?? [];
        const args: MutationUpdateDispatchSummaryMarketBulkArgs = {
          input: {
            updates,
          },
        };
        const opts = { merge: options?.merge ? 'updateDispatchSummaryMarketBulk' : undefined };
        const res = await fn(args, opts);
        return getProperty('updateDispatchSummaryMarketBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    updateDispatchSummaryMarket: fetch,
    useUpdateDispatchSummaryMarket: useService,
  };
})();
